/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';
import { AmplifySignIn } from '@aws-amplify/ui-react';
import { I18n } from '@aws-amplify/core';

const Login = () => {

	return (
		<AmplifySignIn className="login"
			slot="sign-in"
			hideSignUp={true}
			formFields={[
				{
					type: "username",
					label: I18n.get("SIGNIN_USERNAME_LABEL"),
					placeholder: I18n.get("SIGNIN_USERNAME_PLACEHOLDER"),
					required: true,
					inputProps: {
						'data-test': 'sign-in-username-input',
					},
				},
				{
					type: "password",
					label: I18n.get("SIGNIN_PASSWORD_LABEL"),
					placeholder: I18n.get("SIGNIN_PASSWORD_PLACEHOLDER"),
					required: true,
					inputProps: {
						'data-test': 'sign-in-password-input',
					},
				}
			]}>
			<div slot="federated-buttons"></div>
		</AmplifySignIn>
	);
}

export default Login;
